import { __assign } from "tslib";
import { HttpRequest } from "@aws-sdk/protocol-http";
export function userAgentMiddleware(options) {
  return function (next) {
    return function (args) {
      var request = args.request;
      if (!HttpRequest.isInstance(request)) return next(args);
      var headers = request.headers;
      var userAgentHeader = options.runtime === "node" ? "user-agent" : "x-amz-user-agent";

      if (!headers[userAgentHeader]) {
        headers[userAgentHeader] = "" + options.defaultUserAgent;
      } else {
        headers[userAgentHeader] += " " + options.defaultUserAgent;
      }

      if (options.customUserAgent) {
        headers[userAgentHeader] += " " + options.customUserAgent;
      }

      return next(__assign(__assign({}, args), {
        request: request
      }));
    };
  };
}
export var getUserAgentMiddlewareOptions = {
  name: "getUserAgentMiddleware",
  step: "build",
  tags: ["SET_USER_AGENT", "USER_AGENT"]
};
export var getUserAgentPlugin = function getUserAgentPlugin(config) {
  return {
    applyToStack: function applyToStack(clientStack) {
      clientStack.add(userAgentMiddleware(config), getUserAgentMiddlewareOptions);
    }
  };
};